import React, { useState, useContext, useEffect } from 'react'
import { /*Table, Switch,*/ Radio, Select, Col, /*Checkbox,*/ Row, Input, /*Button,*/ Space, Tooltip } from 'antd';
import { TokenVerificationLoggedin, ScreenView, Block_U_Admin } from "../../utils/tokenVerify";
import DownloadOrangeIcon from '../../assets/images/icons/download_csv_icon.svg';
import FileIcon from '../../assets/images/icons/offcanva_file_icon.svg';
import deleteIcon from '../../assets/images/icons/trash.svg';
import uploadIcon from '../../assets/images/icons/upload-cloud.svg';
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../config/config.json";
import constantData from "../../constants/constantData.json";
import { jwtDecode } from "jwt-decode";
import { notifyfailure, notifysuccess, notifycatch } from "../../utils/toast";

const GeneralSetting = () => {
    const loadingContext = useContext(LoadingContext);
    const [/* checkRole */, setCheckRole] = useState("admin")
    const [initialValues, setInitialValues] = useState(null);
    const [isDirty, setIsDirty] = useState(false);

    const [initialPubData, setInitialPubData] = useState(null);

    useEffect(() => {
        TokenVerificationLoggedin();
        ScreenView()
        Block_U_Admin()


        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let checkRole = jwtDecode(token).role;
            setCheckRole(checkRole)


            axios
                .get((configData.SERVER_URL + "ops/getPubDetails?_id="), {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setName(response?.data?.data?.p_name || "");
                    setPoc(response?.data?.data?.poc || "");
                    setCompanyName(response?.data?.data?.o_name || "");
                    setCompanyWebsite(response?.data?.data?.c_website || "");
                    setEmail(response?.data?.data?.email || "");
                    setSelectedIm(response?.data?.data?.im?.label || "");
                    setIm(response?.data?.data?.im?.value || "");
                    setCountry(response?.data?.data?.address?.country || "");
                    setCompanyLinkedin(response?.data?.data?.o_contact || "");

                    setImportUrl(response?.data?.data?.media_link || "");
                    setMediakit2(response?.data?.data?.mediaKit || [])

                    const apiData = response?.data?.data || {};
                    // setInitialPubData(sanitizePubData(apiData));
                    setInitialPubData(apiData);

                    const initial = {
                        name: response?.data?.data?.p_name || "",
                        poc: response?.data?.data?.poc || "",
                        companyName: response?.data?.data?.o_name || "",
                        companyWebsite: response?.data?.data?.c_website || "",
                        selectedIm: response?.data?.data?.im?.label || "",
                        im: response?.data?.data?.im?.value || "",
                        country: response?.data?.data?.address?.country || "",
                        companyLinkedin: response?.data?.data?.o_contact || "",
                        importUrl: response?.data?.data?.media_link || "",
                        mediakit2: response?.data?.data?.mediaKit || []
                    };

                    setInitialValues(initial);
                })
                .catch((error) => {
                    notifyfailure("Failed to fetch the publisher details.")
                });


            axios
                .get(configData.SERVER_URL + "user/countryList", {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    setCountryOptions(response.data.data);
                })
                .catch((error) => { });
        }

        loadingContext.done()
    }, [loadingContext]);



    const [tab] = useState("generalSettings")
    const [buttonValue, setButtonValue] = useState(false);


    const [name, setName] = useState("");
    const [nameIsRequiredError, setNameIsRequiredError] = useState(false);

    const [poc, setPoc] = useState("");
    const [pocIsRequiredError, setPocIsRequiredError] = useState(false);

    const [companyName, setCompanyName] = useState("");
    const [companyNameIsRequiredError, setCompanyNameIsRequiredError] =
        useState(false);

    const [email, setEmail] = useState("");
    // const [emailIsRequiredError, setEmailIsRequiredError] = useState(false);
    // const [emailUrlError, setEmailUrlError] = useState(false);

    const [companyWebsite, setCompanyWebsite] = useState("");
    const [companyWebsiteIsRequiredError, setCompanyWebsiteIsRequiredError] =
        useState(false);
    const [companyWebsiteUrlError, setCompanyWebsiteUrlError] = useState(false);

    const [im, setIm] = useState("");
    const [imIsRequiredError, setImIsRequiredError] = useState(false);

    const [selectedIm, setSelectedIm] = useState("telegram");

    const [countryOptions, setCountryOptions] = useState([]);
    const [country, setCountry] = useState("");
    const [countryIsRequiredError, setCountryIsRequiredError] = useState(false);

    const [companyLinkedin, setCompanyLinkedin] = useState("");
    const [companyLinkedinUrlError, setCompanyLinkedinUrlError] = useState(false);

    const [mediakit, setMediakit] = useState([]);
    const [mediakit2, setMediakit2] = useState([]);
    const [importUrl, setImportUrl] = useState("");
    const [importUrlError, setImportUrlError] = useState(false);



    useEffect(() => {
        if (!initialValues) return;

        const hasChanged =
            name !== initialValues.name ||
            poc !== initialValues.poc ||
            companyName !== initialValues.companyName ||
            companyWebsite !== initialValues.companyWebsite ||
            selectedIm !== initialValues.selectedIm ||
            im !== initialValues.im ||
            country !== initialValues.country ||
            companyLinkedin !== initialValues.companyLinkedin ||
            importUrl !== initialValues.importUrl ||
            JSON.stringify(mediakit2) !== JSON.stringify(initialValues.mediakit2) ||
            mediakit.length > 0; // newly uploaded files

        setIsDirty(hasChanged);
    }, [
        name,
        poc,
        companyName,
        companyWebsite,
        selectedIm,
        im,
        country,
        companyLinkedin,
        importUrl,
        mediakit,
        mediakit2,
        initialValues
    ]);


    // const validateEmail = (email) => { ... }; // unused

    const validateWebsiteUrl = (websiteUrl) => {
        return String(websiteUrl)
            .toLowerCase()
            .match(/.+[.].+/);
    };

    const validateLinkedinUrl = (linkedinUrl) => {
        return String(linkedinUrl)
            .toLowerCase()
            .match(/^(https?:\/\/)?([^/]+\.)?(linkedin\.[a-zA-Z]+\/.*)$/);
    };

    function onChangeName(event) {
        setNameIsRequiredError(false);
        setName(event.target.value);
    }

    function onBlurName(event) {
        if (event.target.value.trim().length === 0) {
            setNameIsRequiredError(true);
        }
        setName(event.target.value.trim());
    }

    function onChangePoc(event) {
        setPocIsRequiredError(false);
        setPoc(event.target.value);
    }

    function onBlurPoc(event) {
        if (event.target.value.trim().length === 0) {
            setPocIsRequiredError(true);
        }
        setPoc(event.target.value.trim());
    }

    function onChangeCompanyName(event) {
        setCompanyNameIsRequiredError(false);
        setCompanyName(event.target.value);
    }

    function onBlurCompanyName(event) {
        if (event.target.value.trim().length === 0) {
            setCompanyNameIsRequiredError(true);
            setCompanyName("");
        }
        setCompanyName(event.target.value.trim());
    }

    // function onChangeEmail(event) { ... } // unused
    // function onBlurEmail(event) { ... } // unused

    function onChangeIm(event) {
        setImIsRequiredError(false);
        setIm(event.target.value);
    }

    function onBlurIm(event) {
        if (event.target.value.trim().length === 0) {
            setImIsRequiredError(true);
        }
        setIm(event.target.value.trim());
    }

    function onChangeSelectedIm(event) {
        setSelectedIm(event);
    }

    function onChangeCompanyWebsite(event) {
        setCompanyWebsite(event.target.value);

        if (event.target.value.length === 0) {
            setCompanyWebsiteUrlError(false);
            setCompanyWebsiteIsRequiredError(true);
        } else {
            setCompanyWebsiteIsRequiredError(false);

            if (validateWebsiteUrl(event.target.value) === null) {
                setCompanyWebsiteUrlError(true);
            } else {
                setCompanyWebsiteUrlError(false);
            }
        }
    }

    function onBlurCompanyWebsite(event) {
        if (event.target.value.trim().length === 0) {
            setCompanyWebsiteUrlError(false);
            setCompanyWebsiteIsRequiredError(true);
        } else {
            if (validateWebsiteUrl(event.target.value.trim()) === null) {
                setCompanyWebsiteUrlError(true);
            } else {
                setCompanyWebsiteUrlError(false);
            }
        }
        setCompanyWebsite(event.target.value.trim());
    }


    function onChangeImportUrl(event) {
        setImportUrl(event.target.value);

        if (event.target.value.length === 0) {
            setImportUrlError(false);

        } else {
            if (validateWebsiteUrl(event.target.value) === null) {
                setImportUrlError(true);
            } else {
                setImportUrlError(false);
            }
        }
    }

    function onBlurImportUrl(event) {
        if (event.target.value.trim().length === 0) {
            setImportUrlError(false);

        } else {
            if (validateWebsiteUrl(event.target.value.trim()) === null) {
                setImportUrlError(true);
            } else {
                setImportUrlError(false);
            }
        }
        setImportUrl(event.target.value.trim());
    }




    function onChangeCompanyLinkedin(event) {
        setCompanyLinkedin(event.target.value);
        if (event.target.value.length === 0) {
            setCompanyLinkedinUrlError(false);
        } else {
            if (validateLinkedinUrl(event.target.value) === null) {
                setCompanyLinkedinUrlError(true);
            } else {
                setCompanyLinkedinUrlError(false);
            }
        }
    }

    function onBlurCompanyLinkedin(event) {
        if (event.target.value.trim().length === 0) {
            setCompanyLinkedinUrlError(false);
        }
        else {
            if (validateLinkedinUrl(event.target.value.trim()) === null) {
                setCompanyLinkedinUrlError(true);
            } else {
                setCompanyLinkedinUrlError(false);
            }
        }
        setCompanyLinkedin(event.target.value.trim());
    }

    function onChangeMediakit(e) {
        let count = 0;

        if (e.target.files.length > 0) {
            let tempMediaKit = [...mediakit];

            for (let file of e.target.files) {

                if (file.size / (1024 * 1024) < 100
                    // && (file.type === "application/vnd.ms-powerpoint" || file.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation")
                ) {
                    tempMediaKit.push({
                        data: file,
                        preview: URL.createObjectURL(file),
                        filename: file.name,
                        size: file.size
                    });
                }
                else {
                    count++;

                }
            }
            setMediakit(tempMediaKit);
            const fileInput00 = document.getElementById("file000");
            fileInput00.value = "";

            if (count !== 0) {
                notifyfailure(`${count} files are rejected as they are failing validation (File should be Less than 100mb `)
            }

            //   } else {
            //     setMediakit({
            //       data: "",
            //       preview: "",
            //     });
            //     setMediakitFilename("");
            //     notifyfailure("File Size Should be less than 100 MB");
            //   }
        }
    }

    const fetchAndDownloadFilesMediaKit = async (ob) => {
        try {

            try {
                const response = await fetch(ob.url);

                if (!response.ok) {
                    throw new Error(`Failed to fetch ${ob?.url}: ${response.statusText}`);
                }

                const blob = await response.blob();
                const filename = `${ob.fileName}${ob.fileName.includes("." + ob?.ext) ? "" : `${"." + ob.ext}`}`;

                // Create a temporary link element
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;

                // Append the link to the body
                document.body.appendChild(link);

                // Programmatically click the link to trigger the download
                link.click();

                // Remove the link from the document
                document.body.removeChild(link);
            } catch (error) {
                console.error("Error fetching file:", error);
            }

            notifysuccess("File downloaded successfully");

        } catch (error) {
            notifyfailure("Error while fetching the media kit.");
        }
    };

    const objectToFormData = (obj) => {
        const formData = new FormData();

        Object.entries(obj).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                formData.append(key, JSON.stringify(value));
            } else if (value !== undefined && value !== null) {
                formData.append(key, value);
            }
        });

        return formData;
    };

    const buildFinalPayload = () => {
        if (!initialPubData) return null;

        return {
            ...initialPubData, // ✅ ALL keys preserved

            // 🔥formatted keys
            // im: JSON.stringify(initialPubData.im), // duplicate key - overridden below
            defineYourself: JSON.stringify(initialPubData.defineYourself),
            inventory_type_select: JSON.stringify(initialPubData.inventory_type_select),
            ad_format_monetise: JSON.stringify(initialPubData.ad_format_monetise),
            ad_format_monetise_other: JSON.stringify(initialPubData.ad_format_monetise_other),
            integration_type: JSON.stringify(initialPubData.integration_type),
            ortb_type: JSON.stringify(initialPubData.ortb_type),
            vast_type: JSON.stringify(initialPubData.vast_type),
            integration_protocol_rich_media_creative: JSON.stringify(initialPubData.integration_protocol_rich_media_creative),
            blockCategory: JSON.stringify(initialPubData.blockCategory),
            bcate_data: JSON.stringify(initialPubData.bcate_data),

            inventoryWebsiteData: initialPubData.inventory_type_select.includes("Website") ? JSON.stringify(initialPubData.inventoryWebsiteData) : [],
            inventoryMobileData: initialPubData.inventory_type_select.includes("Mobile App (Android / iOS)") ? JSON.stringify(initialPubData.inventoryMobileData) : [],
            inventoryCtvData: initialPubData.inventory_type_select.includes("CTV / FAST Apps") ? JSON.stringify(initialPubData.inventoryCtvData) : [],

            //keys to replace / update
            p_name: name,
            poc: poc,
            o_name: companyName,
            c_website: companyWebsite,
            email: email,
            im: JSON.stringify({ "label": selectedIm, "value": im }),
            country: country,
            o_contact: companyLinkedin,
            media_link: importUrl,
            mediaKit: JSON.stringify(mediakit2)

        };
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (

            name !== "" &&
            poc !== "" &&
            companyName !== "" &&
            companyWebsite !== "" &&
            // email !== "" &&
            im !== ""

        ) {
            if (
                nameIsRequiredError === false &&
                pocIsRequiredError === false &&
                companyNameIsRequiredError === false &&
                companyWebsiteUrlError === false &&
                companyWebsiteIsRequiredError === false &&
                // emailIsRequiredError === false &&
                // emailUrlError === false &&
                imIsRequiredError === false &&
                companyLinkedinUrlError === false &&
                importUrlError === false
            ) {

                const finalPayload = buildFinalPayload();
                if (!finalPayload) return;

                const formData = objectToFormData(finalPayload);

                formData.delete('mediaKit_new');
                mediakit.forEach((file) => {
                    formData.append('mediaKit_new', file.data);
                });


                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                    setButtonValue(true);
                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .put(`${configData.SERVER_URL}ops/editPub`, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                "x-access-token": token,
                            }
                        }
                        )
                        .then((response) => {

                            notifysuccess(response.data.message);
                            setTimeout(() => {
                                window.location.reload()
                            }, 1500)


                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                }
                            } else {
                                notifycatch();
                            }
                            setButtonValue(false);
                        });

                }





            }
        } else {
            if (name === "") {
                setNameIsRequiredError(true);
            }
            if (poc === "") {
                setPocIsRequiredError(true);
            }
            if (companyName === "") {
                setCompanyNameIsRequiredError(true);
            }
            if (companyWebsite === "") {
                setCompanyWebsiteIsRequiredError(true);
            }
            // if (email === "") {
            //     setEmailIsRequiredError(true);
            // }
            if (im === "") {
                setImIsRequiredError(true);
            }
            // if (country === "") {
            //     setCountryIsRequiredError(true);
            // }
        }
    };





    return (
        <div className="new_table_select_row_design_cls container_box--wrapper pt_header">
            <div className="container_box--wrapper--title d_flex justify-content-between">
                <h1 className="heading fw_600"> My Account </h1>
                {!buttonValue ?
                    <button className='btn btn_primary w_fit_content md' style={{ padding: '0 4rem' }}
                        onClick={handleSubmit}
                        disabled={!isDirty}
                    >
                        <span>

                            Save
                        </span>
                    </button>
                    :
                    <button className='btn btn_primary w_fit_content md' style={{ padding: '0 3rem' }}
                    >
                        <span>

                            Processing...
                        </span>
                    </button>
                }
            </div>
            <div className="d_flex justify_content_between w_100 mb_10">
                <div className="radios_btns --radios_btns_new">
                    <Radio.Group
                        value={tab}
                        className='radio_btn--group mb-0'>
                        <Radio.Button value="generalSettings">General Settings</Radio.Button>
                        <Radio.Button value="accountSettings" onClick={() => { window.location.replace("/accountSettings") }}>Account Settings</Radio.Button>
                    </Radio.Group>
                </div>

            </div>
            <div className="container_box--form-container bg-transparent border-0 p-0">
                <div className="container_box--width">

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Basic details</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container"
                            //  ref={basicDetailsRef}
                            >
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Publisher Name *</label>
                                            <Input
                                                className={
                                                    nameIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={name}
                                                onBlur={onBlurName}
                                                onChange={onChangeName}
                                                autocomplete="off"
                                            // disabled={isDisabled}


                                            />
                                            <span className='error_content'>
                                                {nameIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Full name of primary POC *</label>
                                            <Input
                                                className={
                                                    pocIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={poc}
                                                onBlur={onBlurPoc}
                                                onChange={onChangePoc}
                                                autocomplete="off"
                                            // disabled={isDisabled}


                                            />
                                            <span className='error_content'>
                                                {pocIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Organisation Name *</label>
                                            <Input
                                                className={
                                                    companyNameIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={companyName}
                                                onBlur={onBlurCompanyName}
                                                onChange={onChangeCompanyName}
                                                autocomplete="off"
                                            // disabled={isDisabled}

                                            />
                                            <span className='error_content'>
                                                {companyNameIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>

                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Company website *</label>
                                            <Input
                                                className={
                                                    (companyWebsiteIsRequiredError || companyWebsiteUrlError)
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={companyWebsite}
                                                onBlur={onBlurCompanyWebsite}
                                                onChange={onChangeCompanyWebsite}
                                                autocomplete="off"
                                            // disabled={isDisabled}

                                            />
                                            <span className='error_content'>
                                                {companyWebsiteIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                                {companyWebsiteUrlError && (
                                                    <> Invalid Website Url</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Email Address *</label>
                                            <Input
                                                className="form_control basic"
                                                value={email}
                                                disabled

                                            />
                                            <span className="error_content"> </span>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">IM * </label>
                                            <Space.Compact className='form_compact'>
                                                <Select
                                                    className='form_select'
                                                    value={selectedIm}
                                                    onChange={onChangeSelectedIm}
                                                    options={constantData.IM_OPTIONS}
                                                // disabled={isDisabled}

                                                />
                                                <Input
                                                    className={imIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                    }
                                                    value={im}
                                                    onChange={onChangeIm}
                                                    onBlur={onBlurIm}
                                                    autocomplete="off"
                                                // disabled={isDisabled}

                                                />
                                            </Space.Compact>
                                            <span className="error_content">
                                                {imIsRequiredError && (
                                                    <> This field is required</>
                                                )}

                                            </span>
                                        </div>
                                    </Col>


                                    <Col span={12}>
                                        <div className="form_content_block--group mb-0">
                                            <label className="form_label">Headquarter Country</label>
                                            <Select
                                                showSearch
                                                // open={true}
                                                placeholder='Select'
                                                optionFilterProp="label"
                                                className="form_select basic showing_placeholder_text"
                                                value={country || undefined}
                                                onChange={(event) => {
                                                    setCountryIsRequiredError(false)
                                                    setCountry(event);
                                                }}
                                                options={countryOptions}
                                            // disabled={isDisabled}

                                            // onSearch={(value) => {
                                            //     console.log('search:', value);
                                            //   }}
                                            />
                                            <span className="error_content"></span>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group mb-0">
                                            <label className="form_label">LinkedIn </label>
                                            <Input
                                                className={companyLinkedinUrlError
                                                    ? "form_control basic error"
                                                    : "form_control basic"
                                                }
                                                placeholder='https://'
                                                value={companyLinkedin}
                                                onBlur={onBlurCompanyLinkedin}
                                                onChange={onChangeCompanyLinkedin}
                                                autocomplete="off"
                                            // disabled={isDisabled}

                                            />
                                            <span className="error_content">
                                                {companyLinkedinUrlError && (
                                                    <> Invalid LinkedIn Url</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Media Kit</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container  mb_0"
                                // ref={importUrlRef}
                                style={{
                                    paddingBottom:
                                        ((mediakit?.length ?? 0) + (mediakit2?.length ?? 0)) === 0 ||
                                            ((mediakit?.length ?? 0) + (mediakit2?.length ?? 0)) === 1
                                            ? "0px"
                                            : undefined
                                }}


                            >


                                {(mediakit?.length + mediakit2?.length) === 0 &&
                                    <Row gutter={16}

                                    >
                                        <>
                                            <Col span={11} className='file_uploaded_view_cls '>

                                                <div className={(mediakit?.length + mediakit2?.length) === 0 ? "form_content_block--group mb-0" : "form_content_block--group mb-3"}>
                                                    <label for='file000' className='ant_upload_drag --updated_design_cls'>
                                                        <div className='d-flex align-items-center justify-content-start' style={{ gap: '1.2rem' }}>
                                                            <p className="upload_drag_icon mx-0">
                                                                <img src={uploadIcon} alt='USP' />
                                                            </p>
                                                            <div className='text-start'>
                                                                <p className="ant_upload_text mt-0"><b className="primary">Click to upload</b> </p>
                                                                <p className="text-start ant_upload_hint">
                                                                    (max. 100 MB)
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </label>
                                                    <input className='form_upload d-none' type="file"
                                                        name="file000"
                                                        id="file000"
                                                        // accept=".ppt, .pptx"
                                                        multiple
                                                        onChange={onChangeMediakit}
                                                    // disabled={isDisabled}
                                                    />

                                                </div>

                                            </Col>
                                            <Col span={1} className="or-col">
                                                <div className="or-divider">
                                                    <span>or</span>
                                                </div>
                                            </Col>
                                            <Col span={12}>
                                                <div className="form_content_block--group">
                                                    <label className="form_label">Import from URL</label>
                                                    <Input
                                                        className={importUrlError ? "form_control basic error" : "form_control basic"}
                                                        placeholder='Paste your media kit URL'
                                                        value={importUrl}
                                                        onChange={onChangeImportUrl}
                                                        onBlur={onBlurImportUrl}
                                                    // disabled={isDisabled}
                                                    />
                                                    <span className="error_content">
                                                        {importUrlError && (
                                                            <> Invalid Url</>
                                                        )}
                                                    </span>
                                                </div>
                                            </Col>

                                        </>
                                    </Row>
                                }

                                {(mediakit?.length + mediakit2?.length) !== 0 &&
                                    <Row gutter={16} >
                                        <Col span={11} className='file_uploaded_view_cls'>


                                            <div className='new_file_upload_design_cls'
                                                style={{ paddingBottom: "0px" }}
                                            >

                                                <div className='d-flex align-items-start justify-content-between'>
                                                    <div style={{ width: "80%" }}>

                                                        {mediakit.map((media, index) => (
                                                            <div className="ant_upload_list--content border-0 padding-0">
                                                                <div className='d-flex align-items-start justify-content-between w-100'>
                                                                    <div className='d-flex align-items-center'
                                                                        style={{ width: "160px" }}
                                                                    >
                                                                        <img src={FileIcon} alt="USP" />
                                                                        <div className="ant_upload_list--info">

                                                                            <span className="ant_upload_list--info-name new_design_name ellipsis-2_text">
                                                                                {/* {media?.filename
                                                                                    ? media.filename.length > 16
                                                                                        ? <Tooltip title={media.filename}>
                                                                                            <span>{media.filename.slice(0, 16)}..</span>
                                                                                        </Tooltip>
                                                                                        : media.filename
                                                                                    : ""} */}
                                                                                <Tooltip title={media.filename}>
                                                                                    {media.filename}
                                                                                </Tooltip>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className='d-flex'>

                                                                        <button type="link" className="ant_upload_list--delete"
                                                                            onClick={() => {
                                                                                let tempMediaKit = [...mediakit];
                                                                                tempMediaKit.splice(index, 1);
                                                                                setMediakit(tempMediaKit);
                                                                            }}
                                                                        // disabled={isDisabled}
                                                                        >
                                                                            <Tooltip title="Delete">
                                                                                <img src={deleteIcon} alt="USP" />
                                                                            </Tooltip>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}

                                                        {mediakit2?.map((media, index) => (
                                                            <div className="ant_upload_list--content border-0 padding-0">
                                                                <div className='d-flex align-items-start justify-content-between  w-100'>
                                                                    <div className='d-flex align-items-center'
                                                                        style={{ width: "160px" }}
                                                                    >
                                                                        <img src={FileIcon} alt="USP" />
                                                                        <div className="ant_upload_list--info">

                                                                            <span className="ant_upload_list--info-name new_design_name ellipsis-2_text">
                                                                                {/* {media?.fileName
                                                                                    ? media.fileName.length > 16
                                                                                        ? <Tooltip title={media.fileName}>
                                                                                            <span>{media.fileName.slice(0, 16)}..</span>
                                                                                        </Tooltip>
                                                                                        : media.fileName
                                                                                    : ""} */}
                                                                                <Tooltip title={media.fileName}>
                                                                                    {media.fileName}
                                                                                </Tooltip>
                                                                            </span>

                                                                        </div>
                                                                    </div>
                                                                    <div className='d-flex'>

                                                                        {media.hasOwnProperty('url') &&
                                                                            <button type="link" className="ant_upload_list--delete"
                                                                                onClick={() => {
                                                                                    fetchAndDownloadFilesMediaKit(
                                                                                        media

                                                                                    )

                                                                                }}
                                                                            >
                                                                                <Tooltip title="Download">
                                                                                    <img src={DownloadOrangeIcon} alt="USP" />
                                                                                </Tooltip>
                                                                            </button>
                                                                        }
                                                                        <button type="link" className="ant_upload_list--delete"
                                                                            onClick={() => {
                                                                                let tempMediaKit = [...mediakit2];
                                                                                tempMediaKit.splice(index, 1);
                                                                                setMediakit2(tempMediaKit);
                                                                            }}
                                                                        // disabled={isDisabled}

                                                                        >
                                                                            <Tooltip title="Delete">
                                                                                <img src={deleteIcon} alt="USP" />
                                                                            </Tooltip>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>

                                                    {/* <hr className='divider_line' /> */}
                                                    <Tooltip title="Upload More">
                                                        <button type="button" className="upload_btn">

                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                <path d="M10.3637 10.3645L7.99924 8L5.63477 10.3645" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M8 8V13.3201" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M12.9591 11.7773C13.5356 11.4629 13.9911 10.9656 14.2536 10.3637C14.516 9.76176 14.5706 9.08958 14.4086 8.45321C14.2467 7.81685 13.8774 7.25255 13.3591 6.84937C12.8408 6.44618 12.203 6.22709 11.5463 6.22665H10.8015C10.6226 5.5346 10.2891 4.89211 9.82612 4.34748C9.36315 3.80286 8.78274 3.37028 8.12852 3.08226C7.4743 2.79425 6.7633 2.65828 6.04897 2.6846C5.33465 2.71092 4.63558 2.89884 4.00433 3.23422C3.37308 3.5696 2.82607 4.04371 2.40444 4.62093C1.9828 5.19814 1.6975 5.86343 1.56999 6.56678C1.44248 7.27013 1.47607 7.99323 1.66825 8.68172C1.86043 9.37022 2.20619 10.0062 2.67953 10.5418" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M10.3637 10.3645L7.99924 8L5.63477 10.3645" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>

                                                            <input className='upload_btn' type="file"
                                                                name="file000"
                                                                id="file000"
                                                                // accept=".ppt, .pptx"
                                                                multiple
                                                                onChange={onChangeMediakit}
                                                            // disabled={isDisabled}
                                                            />
                                                            {/* Upload more */}
                                                        </button>
                                                    </Tooltip>

                                                </div>
                                            </div>


                                        </Col>
                                        <Col span={1} className={((mediakit?.length ?? 0) + (mediakit2?.length ?? 0)) === 1 ? "or-col" : "or-col2"}>
                                            <div className="or-divider">
                                                <span>or</span>
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="form_content_block--group">
                                                <label className="form_label">Import from URL</label>
                                                <Input
                                                    className={importUrlError ? "form_control basic error" : "form_control basic"}
                                                    placeholder='Paste your media kit URL'
                                                    value={importUrl}
                                                    onChange={onChangeImportUrl}
                                                    onBlur={onBlurImportUrl}
                                                // disabled={isDisabled}
                                                />
                                                <span className="error_content">
                                                    {importUrlError && (
                                                        <> Invalid Url</>
                                                    )}
                                                </span>
                                            </div>
                                        </Col>

                                    </Row>
                                }



                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

export default GeneralSetting;
